module.exports = __webpack_public_path__ + "img/t2-4.d94a8ddd.png";